import { BrowserProvider, JsonRpcProvider, Contract } from "ethers";

// Load environment variables
const chainIdHex = `0x${parseInt(process.env.REACT_APP_CHAIN_ID, 10).toString(16)}`; // Convert to hex
const chainName = process.env.REACT_APP_CHAIN_NAME;
const rpcUrl = process.env.REACT_APP_RPC_PROVIDER;
const blockExplorerUrl = process.env.REACT_APP_BLOCK_EXPLORER_URL;
const nativeCurrency = {
  name: process.env.REACT_APP_NATIVE_CURRENCY_NAME,
  symbol: process.env.REACT_APP_NATIVE_CURRENCY_SYMBOL,
  decimals: parseInt(process.env.REACT_APP_NATIVE_CURRENCY_DECIMALS, 10),
};
if (!chainName || !nativeCurrency.name || !nativeCurrency.symbol || isNaN(nativeCurrency.decimals)) {
  console.error('One or more environment variables are missing or invalid:', {
    chainName,
    nativeCurrency,
  });
}
let provider;
const jsonProvider = new JsonRpcProvider(rpcUrl);
// Function to check if the network is correct
export const checkNetwork = async () => {
  if (!provider && typeof window.ethereum !== 'undefined') {
    provider = new BrowserProvider(window.ethereum, "any");
  }
  if (provider) {
    const network = await provider.getNetwork();
    return network.chainId === BigInt(parseInt(process.env.REACT_APP_CHAIN_ID, 10));
  }
  return false;
};// Function to switch to the DApp's network
export const switchTo6DegreeNetwork = async () => {

  if (!provider) return; // Ensure provider exists before trying to switch networks

  const params = [{
    chainId: chainIdHex,
    chainName,
    rpcUrls: [rpcUrl],
    blockExplorerUrls: blockExplorerUrl ? [blockExplorerUrl] : null,
    nativeCurrency, // Use nativeCurrency from env variables
  }];

  try {

    await provider.send('wallet_addEthereumChain', params);
  } catch (error) {
    console.error('Error switching to 6Degree network:', error);
  }
};

// Function to connect to the wallet
export const connectWallet = async () => {
  if (!provider) {
    throw new Error('No Web3 wallet detected. Please install a Web3-compatible wallet.');
  }

  await provider.send("eth_requestAccounts", []);
  const signer = await provider.getSigner();
  const address = await signer.getAddress(); // This line fetches the address correctly

  return { provider, signer, address };
};

// Function to get the contract using JsonRpcProvider
export const getContractThroughJsonProvider = () => {
  return new Contract(process.env.REACT_APP_CONTRACT_ADDRESS, contractABI, jsonProvider);
};

// Function to get the contract with a signer
export const getSignerContract = (signer) => {
  return new Contract(process.env.REACT_APP_CONTRACT_ADDRESS, contractABI, signer);
};

const contractABI = require('./contractABI.json');
